// ftlHesapBekle.js — KAYITTAN SONRA FTL YENİDEN HESABINI BEKLE (3 Eki 2026, adım 1a / 3c)
//
// 🔑 Serkan (3 Eki 2026): *"tek motorumuz tek yolumuz olması gerekir"* — türetilmiş FTL değerlerini (rapor, görev sonu,
//    azami UGS, dinlenme, intibak …) YALNIZ sunucudaki motor yazar; görev kaydı değişince veritabanı tetikleyicisi onu
//    çağırır (20261003b) ve her çağrı `ftl_hesap_defteri`ne bir satır bırakır, sonuç gelince satır kapanır (bitti_at).
// Ekran kaydettikten sonra bu satırların kapanmasını bekler, sonra yeniden okur — böylece gösterdiği değer sunucunun
// yazdığıdır. Bekleme SÜRESİZ değildir ve sonuç GİZLENMEZ:
//   'yok'         — bekleyen hesap yok (kayıt hesabı etkilemedi ya da çoktan bitti)
//   'tamam'       — bekleyen hesapların hepsi 'ok' bitti
//   'hata'        — en az biri hata verdi (sebebi döner) → ekranda kırmızı uyarı
//   'zaman_asimi' — sınır içinde bitmedi → ekranda kırmızı uyarı (değerler bayat olabilir)
//   'okunamadi'   — defter okunamadı → ekranda uyarı
// Bekleyen = şirketin son PENCERE_DK dakikada açılmış ve henüz kapanmamış satırları (tetikleyici satırı kaydın işlemi
// içinde açar; kayıt dönünce satır zaten oradadır). Pencere, takılı kalmış eski bir satırın her kayıtta beklemeye yol
// açmasını önler — takılı satırları gece taraması yakalar.

export const BEKLEME_SINIRI_MS = 15000;
export const SORGU_ARALIGI_MS = 700;
export const PENCERE_DK = 2;

const uyu = (ms) => new Promise(r => setTimeout(r, ms));

export async function hesabiBekle(db, customerId, {
  simdi = () => Date.now(), bekle = uyu, sinirMs = BEKLEME_SINIRI_MS, aralikMs = SORGU_ARALIGI_MS,
} = {}) {
  if (!customerId) return { durum: 'yok' };
  try {
    const esik = new Date(simdi() - PENCERE_DK * 60000).toISOString();
    const { data, error } = await db.from('ftl_hesap_defteri').select('id')
      .eq('customer_id', customerId).is('bitti_at', null).gte('created_at', esik);
    if (error) return { durum: 'okunamadi', hata: error.message };
    const ids = (data || []).map(r => r.id);
    if (!ids.length) return { durum: 'yok' };

    const bas = simdi();
    for (;;) {
      const { data: s, error: e } = await db.from('ftl_hesap_defteri').select('id,sonuc,hata,bitti_at').in('id', ids);
      if (e) return { durum: 'okunamadi', hata: e.message };
      const biten = (s || []).filter(r => r.bitti_at);
      if (biten.length >= ids.length) {
        const hatali = biten.filter(r => r.sonuc !== 'ok');
        return hatali.length
          ? { durum: 'hata', hata: hatali.map(r => r.hata || r.sonuc || 'unknown error').join(' | ') }
          : { durum: 'tamam' };
      }
      if (simdi() - bas >= sinirMs) return { durum: 'zaman_asimi' };
      await bekle(aralikMs);
    }
  } catch (e) {
    return { durum: 'okunamadi', hata: String(e?.message || e) };
  }
}

/** Ekrandaki uyarı metni — bekleme sürerken ve bittiğinde. null = gösterilecek bir şey yok. */
export function hesapUyarisi(sonuc) {
  if (!sonuc) return null;
  if (sonuc === 'bekliyor') return { renk: 'bilgi', metin: 'FTL RECALCULATING… the values below are being recomputed by the server.' };
  if (sonuc.durum === 'hata') {
    return { renk: 'kirmizi', metin: `FTL RECALCULATION FAILED — ${sonuc.hata}. The values shown may be out of date; reload, and tell GO2 if it repeats.` };
  }
  if (sonuc.durum === 'zaman_asimi') {
    return { renk: 'kirmizi', metin: `FTL RECALCULATION DID NOT FINISH IN ${Math.round(BEKLEME_SINIRI_MS / 1000)} SECONDS — the values shown may be out of date; reload in a moment.` };
  }
  if (sonuc.durum === 'okunamadi') {
    return { renk: 'kirmizi', metin: `FTL RECALCULATION STATUS COULD NOT BE READ — ${sonuc.hata}. The values shown may be out of date.` };
  }
  return null;
}
